
import { useSidebar } from "@/context/SidebarContext";
import Dashboard from "@/components/pages/Dashboard";
import Diagramas from "@/components/pages/Diagramas";
import Configuracoes from "@/components/pages/Configuracoes";
import Profile from "@/components/pages/Profile";
import Componentes from "@/components/pages/Componentes";
import ComponentTypes from "@/components/pages/ComponentTypes";
import Leiame from "@/components/pages/Leiame";
import { useLocation } from "react-router-dom";
import DiagramDetails from "@/pages/DiagramDetails";
import ComponentDetails from "@/pages/ComponentDetails";
import Planos from "@/pages/Planos";

export function MainContent() {
  const { currentPage } = useSidebar();
  const location = useLocation();
  
  // Check if we're on details pages
  if (location.pathname.includes('/diagrama-detalhes/')) {
    return (
      <div className="flex-1 overflow-auto">
        <DiagramDetails />
      </div>
    );
  }

  if (location.pathname.includes('/componente-detalhes/')) {
    return (
      <div className="flex-1 overflow-auto">
        <ComponentDetails />
      </div>
    );
  }

  // Check if we're on the planos page
  if (location.pathname === '/planos') {
    return (
      <div className="flex-1 overflow-auto">
        <Planos />
      </div>
    );
  }

  // Check if we're on the profile page
  if (location.pathname === '/profile') {
    return (
      <div className="flex-1 overflow-auto p-8">
        <Profile />
      </div>
    );
  }
  
  // Render appropriate component based on currentPage
  const renderContent = () => {
    switch (currentPage) {
      case "Leiame":
        return <Leiame />;
      case "Dashboard":
        return <Dashboard />;
      case "Diagramas":
        return <Diagramas />;
      case "Componentes":
        return <Componentes />;
      case "TiposComponentes":
        return <ComponentTypes />;
      case "Configuracoes":
        return <Configuracoes />;
      case "MudePlano":
        return <Planos />;
      default:
        return <Dashboard />;
    }
  };
  
  return (
    <div className="flex-1 overflow-auto p-8">
      {renderContent()}
    </div>
  );
}
